import React, { memo, useMemo } from "react";
import { Container } from "@pixi/react";
import { Settings, GAME_LAYOUT } from "../../../settings";
import { FEATURES_CONFIG } from "../../../featuresConfig";
import OverlayReel from "../OverlayReel/OverlayReel";
import { useReelRefs } from "../../../Contexts/ReelRefsContext";
import { useSelector } from "react-redux";
import { selectHoldAndWinActive } from "../../../State/selectors";
import FreeSpinCounter from "../../../Components/Animations/FreeSpin/FreeSpinCounter/FreeSpinCounter";

const OverlayReelSet = memo(({ symbolWidth, symbolHeight, reelSpacing }) => {
  const { overlayReelRefs } = useReelRefs();
  const holdAndWinActive = useSelector(selectHoldAndWinActive);

  // Memoize container Y position calculation
  const containerY = useMemo(
    () => -symbolHeight * (0.5 * Settings.SYMBOLS_VISIBLE - 0.5),
    [symbolHeight]
  );

  // Memoize alpha value
  const containerAlpha = useMemo(
    () => (holdAndWinActive ? 0.001 : 1),
    [holdAndWinActive]
  );

  return (
    <Container
      name="spine_overlay"
      zIndex={5}
      y={containerY}
      alpha={containerAlpha}
    >
      {GAME_LAYOUT.REEL_INDICES.map((index) => (
        <OverlayReel
          key={index}
          symbolHeight={symbolHeight}
          symbolWidth={symbolWidth}
          reelSpacing={reelSpacing}
          overlaySymbols={GAME_LAYOUT.SYMBOL_INDICES}
          ref={(el) => {
            overlayReelRefs.current[index] = el;
          }}
          index={index}
        />
      ))}
      {FEATURES_CONFIG.FREE_SPINS.ENABLED && <FreeSpinCounter />}
    </Container>
  );
});

export default OverlayReelSet;
